// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React from 'react';
import cn from 'classnames';
import {Button} from '../../../../shared/button';
import {use_refund_confirmation} from './use_sa2025';

import styles from './styles.module.less';

interface i_refund_confirmation_props {
    email: string;
    token: string;
    hola_uid?: string;
    on_confirmed: ()=>void;
    on_error: (error_type: string)=>void;
}

export const Refund_confirmation = (props: i_refund_confirmation_props)=>{
    const {on_confirm_refund, is_loading} = use_refund_confirmation(props);
    return <div className={cn(styles.refund_page)}>
      <div className={cn(styles.content)}>
        <div className={cn(styles.heading)}>
          Class action settlement in CA (Dist. - TA) 62567-02-22.
        </div>
        <div className={cn(styles.greeting)}>
          Dear Hola user,
        </div>
        <div className={cn(styles.body)}>
          You are entitled to 3 NIS refund, subject and according to the terms
          of this benefit on Hola's website, and in accordance with the class
          action settlement in CA (Dist. - TA) 62567-02-22
        </div>
        <div className={cn(styles.button_wrapper)}>
          <Button caption={'Confirm refund'}
            size="md" round on_click={on_confirm_refund}
            cls={styles.button} disabled={is_loading}/>
        </div>
        <div className={cn(styles.support)}>
          For any issue please contact support at{' '}
          <a href="mailto:support@hola.org"
            className={cn(styles.support_link)}>
            support@hola.org
          </a>
        </div>
      </div>
    </div>;
};
